var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcDropoff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 9,
    viewBox: "0 0 8 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "4z82hemica",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "url(#4z82hemica)",
    fillRule: "nonzero",
    transform: "translate(-32 -406)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.074 8.214c.151 0 .274-.138.274-.314V5.572c.09-.046.429-.196.958-.196 1.334 0 2.17.757 3.438.757.562 0 .771-.07 1.045-.213.249-.13.411-.348.411-.733V.937c0-.225-.166-.355-.375-.355-.176 0-.508.176-1.128.176C4.43.758 3.597 0 2.26 0c-.562 0-.774.071-1.048.214C.962.344.8.56.8.942V7.9c0 .172.126.314.274.314z",
    transform: "translate(16 268) translate(16 12) translate(0 105) translate(0 13) translate(0 8)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcDropoff);
export default __webpack_public_path__ + "static/media/icon-ic-dropoff.3eb4c5d6.svg";
export { ForwardRef as ReactComponent };